module.exports = "<div *ngIf=\"user | async as dto\" class=\"who pull-left no-padding\">\r\n    <img alt=\"img\" src=\"assets/img/avatars/last-user.png\">\r\n    <span class=\"name\"><b>[{{dto.id}}] {{dto.firstName}} {{dto.lastName}}</b> updated</span>\r\n    <span class=\"from\"><b>{{date | moment: 'ago'}}</b></span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/user/last-user/last-user-component.html
// module id = ./src/app/shared/user/last-user/last-user-component.html
// module chunks = main